import AktenSidebar from './container'
export { AktenSidebar }
export default AktenSidebar